import { useEffect, useState } from "react";

import { GetStoreStrategy, StoreService } from "@/services/store.service";

type UseStoreCodeProps = {
    strategy: GetStoreStrategy;
    startNewSession?: boolean;
};

export const useStoreCode = ({ strategy }: UseStoreCodeProps) => {
    const [storeCode, setStoreCode] = useState(
        StoreService.getStoreCode(strategy)
    );

    const updateStoreCode = () => {
        setStoreCode(StoreService.getStoreCode(strategy));
    };

    // biome-ignore lint/correctness/useExhaustiveDependencies: <TODO>
    useEffect(() => {
        const abortController = new AbortController();

        StoreService.addStoreChangeListener({
            strategy: strategy,
            signal: abortController.signal,
            handler: updateStoreCode
        });

        return () => abortController.abort();
    }, [setStoreCode]);

    return storeCode;
};
